import ShowreelSection from '../Components/Sections/Showreel.Section';
import {AccessBtnComponent} from '../Components/access-btn.component';
import React from 'react';
import {Helmet} from '@dr.pogodin/react-helmet';

export function ShowreelPage() {

    return (
        <>
            <Helmet>
                <title>Showreel - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/showreel`}/>

                <meta name="description"
                      content="Watch the latest showreels showcasing our exceptional 2D art development for slot games. Experience the creativity and quality that Lesia K brings to every project."/>
                <meta name="keywords"
                      content="showreel, 2D art showcase, slot game art, Lesia K showreel, game art portfolio"/>
                <meta property="og:title" content="Showreel - Lesia K Slot 2D Art Development"/>
                <meta property="og:description"
                      content="Watch the latest showreels showcasing our exceptional 2D art development for slot games. Experience the creativity and quality that Lesia K brings to every project."/>
                <meta property="og:url" content="https://lesia-k.com/showreel"/>
                <meta name="twitter:title" content="Showreel - Lesia K Slot 2D Art Development"/>
                <meta name="twitter:description"
                      content="Watch the latest showreels showcasing our exceptional 2D art development for slot games. Experience the creativity and quality that Lesia K brings to every project."/>
            </Helmet>
            <section className={"pb-24 flex flex-col gap-6 justify-center items-center"}>
                <div className={"w-full flex flex-col gap-12 justify-center items-center"}>
                    <ShowreelSection title={'2026'}
                                     videoUrl={'https://storage.googleapis.com/lesia-k/videos/showreel_2026.mp4'}/>
                </div>
                <ShowreelSection title={'2025'}/>

                <AccessBtnComponent text="Contact Now"
                                    className="px-20 md:px-24 py-8 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg bg-pink-600 font-semibold"/>
            </section>
        </>
    )
}
